import React, { useState, useEffect } from 'react'
import { ScrollButton } from './ToDownload.styles'

/**
 * Scroll up Button Component.
 */

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <ScrollButton onClick={scrollToTop} opacity={isVisible} aria-label="Scroll to top">
      ↑
    </ScrollButton>
  )
}

export default ScrollToTopButton
